<template>
  <div class="content">
    <el-tabs class="tabLv3 historAlarm" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 报备管理
        </span>
        <div class="normalNav zaddBtn">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
        </div>
        <div class="searchForm1 alarmSearchForm">
          <el-form :class="className">
            <el-form-item label="片区名称">
              <el-input
                placeholder="请输入片区名称"
                v-model.trim="searchForm.districtName"
                type="text"
              ></el-input>
            </el-form-item>
            <el-form-item label="单位名称">
              <el-input
                placeholder="请输入单位名称"
                v-model.trim="searchForm.unitName"
                type="text"
              ></el-input>
            </el-form-item>
            <el-form-item label="设备编码">
              <el-input
                placeholder="请输入设备编码"
                v-model.trim="searchForm.deviceMark"
                type="text"
              ></el-input>
            </el-form-item>
            <el-form-item label="设备名称">
              <el-input
                placeholder="请输入设备名称"
                v-model.trim="searchForm.deviceName"
                type="text"
              ></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="searchForm.status" placeholder="请选择">
                <el-option
                  v-for="item in gradeOptions"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <template>
              <span class="collapseIcon" @click="className = 'expand'"
                ><img
                  v-default-img
                  :src="require('../../../public/searchForm/collapse.png')"
                  alt=""
              /></span>
              <span class="expandIcon" @click="className = 'collapse'"
                ><img
                  v-default-img
                  :src="require('../../../public/searchForm/expand.png')"
                  alt=""
              /></span>
            </template>
          </el-form>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <el-table
            :data="tableData"
            style="width: 100%"
            class="stripeTable"
            stripe
          >
            <el-table-column
              show-overflow-tooltip
              v-for="{ prop, label } in tableLable"
              :key="prop.toString()"
              :label="label"
              :prop="prop"
              :render-header="labelHead"
            >
            </el-table-column>
            <el-table-column label="操作" width="200" align="left">
              <template slot-scope="scope">
                <el-link
                  icon="iconfont iconwhole"
                  type="text"
                  size="small"
                  @click="openDetailDialog(scope.row)"
                  >详情</el-link
                >
                <el-link
                  icon="iconfont iconcheck"
                  type="text"
                  size="small"
                  @click="openFilingDialog(scope.row)"
                  v-if="scope.row.status == 0"
                  >报备</el-link
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination
              v-if="flagShow"
              layout="prev, pager, next"
              :page-size="10"
              @current-change="handleCurrentChange"
              :total="nTotal"
            >
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 报备弹窗 -->
    <el-dialog
      title="告警报备"
      :visible.sync="filingDialogVisible"
      width="600px"
      :before-close="closeFilingDialog"
    >
      <el-form :model="filingForm" :rules="filingRules" ref="filingForm">
        <el-form-item label="报备原因类型" prop="reasonType">
          <el-select
            v-model="filingForm.reasonType"
            placeholder="请选择报备原因类型"
          >
            <el-option
              v-for="item in reasonTypeOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报备描述" prop="description">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入报备描述"
            v-model="filingForm.description"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeFilingDialog">取 消</el-button>
        <el-button type="primary" @click="submitFiling">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 详情弹窗 -->
    <el-dialog
      title="报备详情"
      :visible.sync="detailDialogVisible"
      width="700px"
      :before-close="closeDetailDialog"
      class="detailDialog"
    >
      <el-form :model="detailForm" size="small">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="设备名称">
              <span>{{ detailForm.deviceName || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="设备编码">
              <span>{{ detailForm.deviceMark || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="单位名称">
              <span>{{ detailForm.unitName || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="片区名称">
              <span>{{ detailForm.districtName || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="开始时间">
              <span>{{ detailForm.startTime || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="结束时间">
              <span>{{ detailForm.endTime || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="报备状态">
              <span>{{ detailForm.statusName || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="告警次数">
              <span>{{ detailForm.alarmNum || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="告警时间">
              <span>{{ detailForm.alarmTime || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="报备次数">
              <span>{{ detailForm.reportNum || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="报备时长（分钟）">
              <span>{{ detailForm.reportInterval || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="恢复时长（分钟）">
              <span>{{ detailForm.recoverInterval || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="报备原因类型">
              <span>{{ detailForm.reasonTypeName || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="报备描述">
              <span>{{ detailForm.description || "-" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDetailDialog">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      className: "collapse",
      tabName: "jsgl",
      searchForm: {
        districtName: "",
        unitName: "",
        deviceMark: "",
        deviceName: "",
        status: ""
      },
      gradeOptions: [
        { name: "未报备", value: 0 },
        { name: "已报备", value: 1 }
      ],
      showTable: true,
      tableLable: [
        {
          prop: "startTime",
          label: "报备开始时间"
        },
        {
          prop: "districtName",
          label: "片区名称"
        },
        {
          prop: "unitName",
          label: "单位名称"
        },
        {
          prop: "deviceName",
          label: "设备名称"
        },
        {
          prop: "endTime",
          label: "报备结束时间"
        },
        {
          prop: "reasonTypeName",
          label: "报备原因类型"
        },
        {
          prop: "statusName",
          label: "报备状态"
        }
      ],
      nTotal: 0,
      currentPage: 1,
      tableData: [],
      flagShow: true,
      // 报备弹窗相关数据
      filingDialogVisible: false,
      currentRow: null,
      filingForm: {
        reasonType: "",
        description: ""
      },
      reasonTypeOptions: [],
      filingRules: {
        reasonType: [
          { required: true, message: "请选择报备原因类型", trigger: "change" }
        ],
        description: [
          { required: true, message: "请输入报备描述", trigger: "blur" }
        ]
      },
      // 详情弹窗相关数据
      detailDialogVisible: false,
      detailForm: {}
    };
  },
  computed: {},
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getInfoDate(val, this.pagesize);
    },
    // 获取后台数据
    getInfoDate(page, pagesize) {
      let formData = JSON.parse(JSON.stringify(this.searchForm));
      this.$axiospost("operation/deviceAlarmReport/pages", {
        ...formData,
        pageNum: page,
        pageSize: pagesize
      }).then(res => {
        this.tableData = res.data.data.list;
        this.nTotal = res.data.data.total;
        this.flagShow = true;
      });
    },
    // 表头全显
    labelHead(h, { column, index }) {
      let l = column.label.length;
      let f = 21; //每个字大小，其实是每个字的比例值，大概会比字体大小差不多大一点，
      column.minWidth = f * l; //字大小乘个数即长度 ,注意不要加px像素，这里minWidth只是一个比例值，不是真正的长度 //然后将列标题放在一个div块中，注意块的宽度一定要100%，否则表格显示不完全
      return h("div", { class: "table-head", style: { width: "100%" } }, [
        column.label
      ]);
    },

    reset() {
      this.searchForm = {
        deviceMark: "",
        deviceName: "",
        unitName: "",
        districtName: "",
        status: ""
      };
      this.currentPage = 1;
    },
    subSeefrom() {
      this.flagShow = false;
      this.getInfoDate(this.currentPage, this.pagesize);
    },
    // 打开报备弹窗
    openFilingDialog(row) {
      this.currentRow = row;
      this.filingForm = {
        reasonType: "",
        description: ""
      };
      this.filingDialogVisible = true;
    },

    // 关闭报备弹窗
    closeFilingDialog() {
      this.filingDialogVisible = false;
      this.filingForm = {
        reasonType: "",
        description: ""
      };
      this.$refs.filingForm && this.$refs.filingForm.resetFields();
    },

    // 提交报备
    submitFiling() {
      this.$refs.filingForm.validate(valid => {
        if (valid) {
          // 发送请求更新报备信息
          this.$axiospost("operation/deviceAlarmReport/update", {
            id: this.currentRow.id,
            reasonType: Number(this.filingForm.reasonType),
            description: this.filingForm.description,
            status: 1 // 可能需要设置为报备状态
          })
            .then(res => {
              if (res.data.status === "10000") {
                this.$message.success("报备成功");
                this.closeFilingDialog();
                // 刷新列表
                this.getInfoDate(this.currentPage, this.pagesize);
              } else {
                this.$message.error("报备失败：" + res.data.message);
              }
            })
            .catch(err => {
              this.$message.error("报备失败：" + err.message);
            });
        } else {
          console.log("验证失败!");
          return false;
        }
      });
    },
    // 打开详情弹窗
    openDetailDialog(row) {
      this.detailForm = { ...row }; // 复制行数据到详情表单
      this.detailDialogVisible = true;
    },

    // 关闭详情弹窗
    closeDetailDialog() {
      this.detailDialogVisible = false;
      this.detailForm = {};
    }
  },
  mounted() {
    this.getInfoDate(this.currentPage, this.pagesize);
    this.$axiosget("/operation/dictionaryData/queryByKey", {
      params: {
        key: "alarmReportReasonType"
      }
    }).then(res => {
      this.reasonTypeOptions = res.data.data;
    });
  }
};
</script>
<style lang="less" scoped>
/deep/.el-form .el-form-item__label {
  width: 120px;
}
/deep/.el-form .el-form-item__content {
  margin-left: 40px;
}
/deep/.detailDialog .el-form .el-form-item__label {
  width: 140px;
}
/deep/.detailDialog .el-form .el-form-item__content {
  margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/alarm/filing.vue